
import PropTypes from 'prop-types'
import React from 'react'
import './Code.css'

const Code = props => {
  let code = props.children
  // this is here to support rendering both React components and text
  if (Array.isArray(props.children)) {
    code = props.children[0].trim()
  }
  const style = { paddingLeft: props.hideGutter ? '20px' : '50px' }

  return (
    <div className='ui-Code' style={style}>
      {props.hideGutter ? null : <div className='ui-Code-gutter'>{lineNumbers(code)}</div>}
      <div className='ui-Code-code'>
        {code}
      </div>
    </div>
  )
}

/**
 * Generate line numbers from `code`.
 *
 * @param {String} code
 * @return {String}
 */

function lineNumbers (code) {
  return code
    .split('\n')
    .map((_, i) => i + 1)
    .join('\n')
}

Code.propTypes = {
  children: PropTypes.string.isRequired,
  hideGutter: PropTypes.bool
}

Code.displayName = 'Code'

export default Code



// WEBPACK FOOTER //
// ./ui/Code.js